import { render, staticRenderFns } from "./FormEvalDocente.vue?vue&type=template&id=57be5c2c"
import script from "./FormEvalDocente.vue?vue&type=script&lang=js"
export * from "./FormEvalDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports